module.exports = "/images/everestPath1.png?965a19d911570fad8434e7ab3cadc847";